
export default (props, inject) => {
  const getCookiesOpt = function (initOptions = {}) {

    let options = { ...initOptions };

    // Если в ENV есть BASE_COOKIE_DOMAIN
    if ( !!props?.env?.baseCookieDomain ) {
      options.domain = props.env.baseCookieDomain;
    }

    options.path = options?.path || "/"

    return options
  }

  inject('getCookiesOpt', getCookiesOpt)
}
